import Echo from "laravel-echo";
import Pusher from "pusher-js";

declare global {
  interface Window {
    Pusher: any;
    Echo: any;
  }
}

export default defineNuxtPlugin(() => {
  window.Pusher = Pusher;
  const { public: publicConfig } = useRuntimeConfig();
  // console.log(publicConfig);
  window.Echo = new Echo({
    broadcaster: publicConfig.pusherBroadcaster,
    key: publicConfig.pusherAppKey,
    wsHost: publicConfig.pusherHost,
    wsPort: publicConfig.pusherPort,
    cluster: publicConfig.pusherCluster,
    forceTLS: publicConfig.pusherTLS,
    authEndpoint: publicConfig.authEndpoint,
  });
});
